import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

let gotoQueue = null;
window.goTo = (url) => {
  gotoQueue = url;
};

const GoTo = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.goTo = (url) => navigate(url);
    window.goTo.initialized = true;

    if (gotoQueue) {
      window.goTo(gotoQueue);
      gotoQueue = null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default GoTo;
